'use client'

import { useEffect, useState } from 'react'
import { loadPulseInstallers, pulsePlatform, type InstallerState, type PulsePlatform } from '@/lib/tracker/releases'

export function usePulseInstallers() {
  const [installers, setInstallers] = useState<Record<PulsePlatform, InstallerState>>({ mac: null, windows: null })
  const [current, setCurrent] = useState<PulsePlatform | null>(null)
  useEffect(() => {
    let active = true
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), 8000)
    setCurrent(pulsePlatform(navigator.userAgent, navigator.maxTouchPoints))
    void loadPulseInstallers((platform, value) => {
      if (active) setInstallers(previous => ({ ...previous, [platform]: value }))
    }, controller.signal).finally(() => clearTimeout(timeout))
    return () => { active = false; clearTimeout(timeout); controller.abort() }
  }, [])
  return { installers, current }
}
